export const sortAlpha = (arg1: string, arg2: string, options?: Intl.CollatorOptions) =>
  (arg1 ?? "").localeCompare(arg2 ?? "", "en", { sensitivity: "base", ...options });
